import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LanguageContext";

const STORAGE_KEY = "tribeo_cookie_consent_v1";

type Consent = "all" | "necessary";

const CookieBanner = () => {
  const { lang } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v) setOpen(true);
  }, []);

  const decide = (c: Consent) => {
    localStorage.setItem(STORAGE_KEY, c);
    window.dispatchEvent(new CustomEvent("tribeo-consent-changed", { detail: c }));
    setOpen(false);
  };

  if (!open) return null;

  const t = lang === "nl"
    ? {
        title: "Cookies op tribeo.co",
        body: "We gebruiken functionele cookies om de site te laten werken en, alleen met jouw toestemming, analytische cookies om de site te verbeteren. We gebruiken geen marketingcookies.",
        accept: "Alles accepteren",
        only: "Alleen noodzakelijk",
        more: "Lees ons cookiebeleid",
      }
    : {
        title: "Cookies on tribeo.co",
        body: "We use functional cookies to make the site work and, only with your consent, analytics cookies to improve it. We do not use marketing cookies.",
        accept: "Accept all",
        only: "Only necessary",
        more: "Read our cookie policy",
      };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50">
      <div className="rounded-2xl border border-border bg-background shadow-elegant p-5">
        <div className="text-sm font-bold">{t.title}</div>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{t.body}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          <Button onClick={() => decide("all")} size="sm" className="rounded-full">{t.accept}</Button>
          <Button onClick={() => decide("necessary")} size="sm" variant="outline" className="rounded-full">{t.only}</Button>
        </div>
        <Link to="/cookies" className="mt-3 inline-block text-xs text-muted-foreground underline hover:text-foreground">{t.more}</Link>
      </div>
    </div>
  );
};

export default CookieBanner;
